import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyB5aGeaP3b7TopMDKuy1b4aIVbSE47XfoI",
  authDomain: "luxe-unbounded.firebaseapp.com",
  projectId: "luxe-unbounded",
  storageBucket: "luxe-unbounded.appspot.com",
  messagingSenderId: "787656029285",
  appId: "1:787656029285:web:d89161abe64bc20479c28c"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

const secondaryApp = initializeApp(firebaseConfig, 'Secondary');
export const secondaryAuth = getAuth(secondaryApp);
